import { IOrbitInfo, OrbitEndpoints } from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import {
  useAuthApiDelete,
  useAuthApiGetMultiFetch,
  useAuthApiPost,
  useAuthApiUpdate,
  type ServiceQueryOptions,
} from '@/dataAccess/rest/apiHooks';

export const useAllOrbitDevices = ({ enabled }: ServiceQueryOptions = {}) => {
  return useAuthApiGetMultiFetch<IOrbitInfo>({
    baseApiRoute: API_NAMES.orbitApi,
    cacheKeys: [CACHE_KEYS.allOrbitDevices],
    routesArray: [OrbitEndpoints.sensorEndpoint],
    enabled,
  });
};

export const useAddOrbitDevice = (identifier?: string) => {
  return useAuthApiPost({
    baseApiRoute: API_NAMES.orbitApi,
    route: OrbitEndpoints.sensorEndpoint,
    cacheKeys: [CACHE_KEYS.allOrbitDevices],
    identifier: identifier,
  });
};

export const useUpdateOrbitDevice = (id: string | undefined, identifier?: string) => {
  return useAuthApiUpdate({
    baseApiRoute: API_NAMES.orbitApi,
    route: OrbitEndpoints.sensorEndpoint,
    id: id ?? '',
    cacheKeys: [CACHE_KEYS.allOrbitDevices],
    identifier: identifier,
    putOrPatch: 'PUT',
  });
};

export const useRemoveOrbitDevice = (device: IOrbitInfo | null) => {
  return useAuthApiDelete({
    baseApiRoute: API_NAMES.orbitApi,
    cacheKeys: [CACHE_KEYS.allOrbitDevices],
    id: device?.id ?? '',
    identifier: device?.name,
    route: OrbitEndpoints.sensorEndpoint,
  });
};
